import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <img
            src="https://static.readdy.ai/image/592edeeb72878c36421bcef1375eb795/ada717a8cd0c75d288b3cd925c344017.png"
            alt="A&S Cleaning Service"
            className="h-20 w-auto object-contain mb-4"
          />
          <p className="text-sm leading-relaxed text-gray-400">
            Professional cleaning services for homes and businesses throughout Port St. Lucie and Martin County, Florida.
          </p>
          <div className="flex items-center gap-3 mt-5">
            <a href="https://facebook.com" rel="nofollow" target="_blank" className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-700 hover:bg-emerald-600 transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-sm" />
            </a>
            <a href="https://instagram.com" rel="nofollow" target="_blank" className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-700 hover:bg-emerald-600 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-sm" />
            </a>
            <a href="https://google.com" rel="nofollow" target="_blank" className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-700 hover:bg-emerald-600 transition-colors cursor-pointer">
              <i className="ri-google-line text-sm" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 id="footer-quick-links" className="text-white font-bold text-base mb-5">
            <a href="#footer-quick-links">Quick Links</a>
          </h4>
          <ul className="space-y-3 text-sm">
            {[
              { label: 'Home', path: '/' },
              { label: 'Services', path: '/services' },
              { label: 'Portfolio', path: '/portfolio' },
              { label: 'Locations', path: '/locations' },
              { label: 'Contact Us', path: '/contact' },
            ].map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="hover:text-emerald-400 transition-colors cursor-pointer">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 id="footer-services" className="text-white font-bold text-base mb-5">
            <a href="#footer-services">Our Services</a>
          </h4>
          <ul className="space-y-3 text-sm">
            {[
              'Residential Cleaning',
              'Commercial Cleaning',
              'Deep Cleaning',
              'Move In / Move Out',
              'Post-Construction',
              'Recurring Maintenance',
            ].map((s) => (
              <li key={s}>
                <Link to="/services" className="hover:text-emerald-400 transition-colors cursor-pointer">{s}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 id="footer-contact" className="text-white font-bold text-base mb-5">
            <a href="#footer-contact">Contact Us</a>
          </h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5"><i className="ri-map-pin-line text-emerald-400" /></div>
              <span className="text-gray-400">Port St. Lucie &amp; Martin County, FL</span>
            </li>
            <li className="flex items-center gap-3">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-line text-emerald-400" /></div>
              <a href="tel:+17725550100" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">561-846-1326</a>
            </li>
            <li className="flex items-center gap-3">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-mail-line text-emerald-400" /></div>
              <a href="mailto:asprestigecleaningservice62@gmail.com" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">asprestigecleaningservice62@gmail.com</a>
            </li>
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5"><i className="ri-time-line text-emerald-400" /></div>
              <span className="text-gray-400">Mon–Fri: 8am–5pm<br />Sat: 9am–4pm</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <p>&copy; {new Date().getFullYear()} A&amp;S Cleaning Service. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/contact" className="hover:text-emerald-400 transition-colors cursor-pointer">Privacy Policy</Link>
            <Link to="/contact" className="hover:text-emerald-400 transition-colors cursor-pointer">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
